<template>
  <div class="home">
      <v-parallax src="https://d176s39pnpenan.cloudfront.net/wp-content/uploads/2020/01/BARBEARIA-ARACAJU-BARBEIRO-MESTRE.png" class="mb-10">
         <v-row align="center" justify="center" >
           <v-flex xs12 sm12 md12 lg12 >
             <v-col class="text-center ">
              
              <img src="/imgs/logo.PNG" width="350" class="zoom">
             
            
           </v-col>

           </v-flex>
           
         </v-row>
      </v-parallax>



  <Agendamento class="mb-10" />
  <br>
  <WhatsappContato class="mt-15" />
  <br>
    
  </div>
</template>

<script>
// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
import Agendamento from '@/components/Agendamento.vue'
import WhatsappContato from '@/components/WhatsappContato.vue'

export default {

  name: 'Home',
  components: {
  //  HelloWorld
  Agendamento,
  WhatsappContato
  }
}
</script>

<style >
 zoom {
  padding: 50px;
  background-color: green;
  transition: transform 1.2s; /* Animation */
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.zoom:hover {
  transition: 1s;
  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
</style>
